"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

var _FormGroup = _interopRequireDefault(require("../../FormGroup"));

var _Checkbox = require("../../Checkbox");

var _SelectButton = _interopRequireDefault(require("../SelectButton"));

var _SelectControls = _interopRequireDefault(require("./SelectControls"));

var _types = require("../../../types");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** DO If used in a table header for filtering, idle will show on table header column hover.
 *
 *
 * DONT Idle boxed is only used rarely and is not used in table headers for filtering. */
var MultiSelectMini = /*#__PURE__*/function (_Component) {
  _inherits(MultiSelectMini, _Component);

  var _super = _createSuper(MultiSelectMini);

  function MultiSelectMini(props) {
    var _this;

    _classCallCheck(this, MultiSelectMini);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        opened: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState(function (_ref) {
        var focused = _ref.focused;
        return {
          focused: !focused
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDropdown", function () {
      _this.setState(function (_ref2) {
        var opened = _ref2.opened;
        return {
          opened: !opened
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterOptions", function (_ref3) {
      var value = _ref3.target.value;

      _this.setState({
        filteredOptions: (0, _utils.filterOptions)(_this.props.options, value)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleItem", function (value) {
      _this.setState({
        selectedOptions: value
      }, _this.props.onSelect(value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckAllChange", function () {
      _this.setState({
        selectedOptions: _this.props.options
      }, _this.props.onSelect(_this.props.options));
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnCheckAllChange", function () {
      _this.setState({
        selectedOptions: []
      }, _this.props.onSelect([]));
    });

    _this.state = {
      focused: false,
      opened: false,
      filteredOptions: _this.props.options,
      selectedOptions: _this.props.value,
      // eslint-disable-next-line react/no-unused-state
      inputValue: props.value
    };
    return _this;
  }

  _createClass(MultiSelectMini, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          boxed = _this$props.boxed,
          headerControls = _this$props.headerControls,
          _this$state = this.state,
          focused = _this$state.focused,
          opened = _this$state.opened,
          selectedOptions = _this$state.selectedOptions,
          filteredOptions = _this$state.filteredOptions;
      return /*#__PURE__*/_react.default.createElement(_reactOutsideClickHandler.default, {
        onOutsideClick: this.handleClickOutside
      }, /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
        focused: focused,
        opened: opened
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "select select__multi-mini"
      }, /*#__PURE__*/_react.default.createElement(_SelectButton.default, {
        ariaControlName: "multiselectFilter-dropdown",
        mini: true,
        boxed: boxed,
        checked: selectedOptions.length > 0,
        onChange: this.onCheckAllChange,
        onFocus: this.handleFocus,
        onBlur: this.handleFocus,
        onClick: this.handleDropdown
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "select__dropdown select__dropdown_mini",
        id: "multiselectFilter-dropdown"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "select__search",
        type: "search",
        "aria-label": "Type to filter available options",
        onChange: this.filterOptions
      }), /*#__PURE__*/_react.default.createElement("fieldset", {
        id: "multiselectFilter-dropdown-options"
      }, /*#__PURE__*/_react.default.createElement("legend", {
        hidden: true
      }, "Options"), /*#__PURE__*/_react.default.createElement(_Checkbox.CheckboxGroup, {
        className: "checkbox-group_select",
        value: selectedOptions,
        options: filteredOptions,
        onChange: function onChange(value) {
          return _this2.toggleItem(value);
        }
      })), /*#__PURE__*/_react.default.createElement(_SelectControls.default, {
        check: this.handleCheckAllChange,
        uncheck: this.handleUnCheckAllChange,
        selectControlsLabel: headerControls.selectControlsLabel
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref4, _ref5) {
      var value = _ref4.value;
      var inputValue = _ref5.inputValue;
      return !(0, _isEqual.default)(value, inputValue) && {
        inputValue: inputValue,
        selectedOptions: value
      };
    }
  }]);

  return MultiSelectMini;
}(_react.Component);

MultiSelectMini.propTypes = {
  /** Option list  */
  options: _types.optionsList,

  /** Initial option for select */
  value: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Wether the select button has border around */
  boxed: _propTypes.default.bool,
  onSelect: _propTypes.default.func,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    })
  })
};
MultiSelectMini.defaultProps = {
  options: null,
  value: [],
  boxed: false,
  onSelect: function onSelect() {},
  headerControls: {
    selectControlsLabel: {
      selectAll: 'Select all',
      reset: 'Reset'
    }
  }
};
var _default = MultiSelectMini;
exports.default = _default;